import type { ReactNode } from 'react';

export const symbol_wifi_protected_setup: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M670-247q-22 19-21-3t4-30q5-18 7-36.5t2-38.5q0-80-35-146.5T532-612l-66 66q-7 7-16.5 3.5T440-556v-254q0-13 8.5-21.5T470-840h254q10 0 13.5 9.5T734-814l-66 66q52 47 83 112t31 141q0 45-11.5 86.5T739-330q-14 25-30.5 45T670-247ZM226-146l66-66q-53-47-83.5-112T178-465q0-45 11.5-86.5T221-630q14-25 30.5-45t38.5-38q22-18 21.5 3t-3.5 29q-5 18-7.5 37t-2.5 39q0 80 35.5 146.5T428-348l66-66q7-7 16.5-3.5T520-404v254q0 13-8.5 21.5T490-120H236q-10 0-13.5-9.5T226-146Z"
		/>
	</svg>
);
